import { httpRequest } from '@calendly/http-tools'
import { createAsyncThunk } from '@reduxjs/toolkit'

import { selectExternalCustomerId } from '../checkout_info_slice'
import { checkoutExternalCustomerSelector } from '../modals/subscription_modal/payment_modal/subscription_checkout/selectors'

export const fetchToken = createAsyncThunk(
  'taxExemptForm/fetchToken',
  async (customerId, { rejectWithValue }) => {
    if (!customerId) {
      return rejectWithValue({})
    }

    const [success, data] = await httpRequest({
      url: '/api/billing/cert_capture_tokens',
      method: 'POST',
      params: { external_customer_id: customerId }
    })

    if (!success) {
      return rejectWithValue(data)
    }

    return data.token
  }
)

const fetchExternalCustomerId = () => async (dispatch, getState) => {
  const state = getState()
  const customerId = checkoutExternalCustomerSelector(state)
  if (customerId) return customerId

  const [_success, customerData] = await httpRequest({
    url: '/api/billing/customer',
    method: 'POST'
  })
  const newCustomerId = customerData.id

  dispatch(selectExternalCustomerId(newCustomerId))

  return newCustomerId
}


export const fetchCertCaptureToken = () => async (dispatch) => {
  const customerId = await dispatch(fetchExternalCustomerId())

  dispatch(fetchToken(customerId))
}
